<template>
    <v-container grid-list-md fluid>
        <img class="text-center" alt="Master Meal Planner logo" src="@/assets/logo.png" id="logo" @click="goToPath('/')">
        <h1 class="mmp-title">Master Meal Planner</h1>
        <div class="white-card">
            <h1 class="content-title">SHARE A RECIPE</h1>
            <iframe src="https://services.cognitoforms.com/f/u5vx8UXMRU-V5VTTzNYvcg?id=2" style="position:relative;width:1px;min-width:100%;*width:100%;" frameborder="0" scrolling="yes" seamless="seamless" height="646" width="100%"></iframe>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "Recipe-Share",
        props: {
            // msg: String
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
        },
        mounted() {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://services.cognitoforms.com/scripts/embed.js')
            document.head.appendChild(recaptchaScript)
        },
        methods: {
            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    #logo {
        margin-top:5px;
        margin-bottom:5px;
        width: 150px;
    }
    .mmp-title {
        text-align:center;
        font-size:40px;
        line-height: 42px;
        font-weight:bold;
        margin:0px 0px 20px 0px;
    }     
    #mc_embed_signup {
        /* background:#fff; */
        clear: left;
        font: 14px Helvetica, Arial, sans-serif;
        width: 80%;
        margin: auto;
    }
    #mc_embed_signup .button {
        background-color: #41d8d5;
        color: #fff;
        height: 40px;
        /* min-width: 150px; */
        font-weight: 400;
        font-size: 18px;
        border: 3px solid #fff;
    }
    .content-title {
        text-align:center;
        font-size:28px;
        font-weight:bold;
        margin: 20px 0px 10px 0px;
    }  
    .content-subTitle {
        font-size:20px;
        max-width: 60%;
        font-weight:normal;
        margin: auto;
    }
    .content-text {
        padding: 0px;
        font-size:16px;        
    }    
    .copyright {
        margin: auto;
        font-size: 11px;
        color: #333;
        padding-top: 10px;
    }
</style>
